/*
 * @Author: Teemo Ding
 * @Date: 2021-03-05 14:45:18
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-13 14:46:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Taxes/TaxListPage/slice/index.tsx
 */
import { unique } from '@/src/tools/helper';
import { createSlice } from '@reduxjs/toolkit';

const defaultState = {
  tabsActive: '',
  searchList: [],
  searchText: 0,
  filter: {},
  tableSettings: [],
  sort: {},
};
//TODO:Filter单选和多选的问题
const storeSettingTaxListSlice = createSlice({
  name: 'storeSettingTaxList',
  initialState: defaultState,
  reducers: {
    saveSearchList: (state, action) => {
      state.searchList.push(action.payload);
      state.searchList = unique(state.searchList); //去重
    },
    deleteSearch: (state, action) => {
      state.searchList.splice(action.payload, 1);
    },
    onFilter: (state, action) => {
      state.filter = action.payload;
    },
    eachOnFilter: (state, action) => {
      state.filter[action.payload.key] = action.payload.data;
    },
    filterClose: (state, action) => {
      state.filter[action.payload.key].splice(action.payload.index, 1);
    },
    activeChange: (state, action) => {
      state.tabsActive = action.payload;
    },
    setTableSetting: (state, action) => {
      state.tableSettings = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    removeFilter: (state) => {
      state.searchList = [];
      state.filter = {};
    },
  },
});

export const {
  saveSearchList,
  deleteSearch,
  onFilter,
  eachOnFilter,
  activeChange,
  filterClose,
  removeFilter,
  setTableSetting,
  setSort,
} = storeSettingTaxListSlice.actions;

export default storeSettingTaxListSlice.reducer;
